import {
  Box,
  Button,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  HandsFistIcon,
  LoadingSpinner,
  UploadIcon,
} from "./ui-elements/svg-icons";
import { useNotificationService } from "../hooks/notification";
import { apiSignPetition } from "../api/post";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LineProgress from "./ui-elements/line-progress";
import { textSty } from "./ui-elements/styles-input";
import { useSelector } from "react-redux";
import { RootState } from "../store/store";
import useResponsive from "../hooks/useResponsive";

const SignPetitionContainer = ({ data }: { data: any }) => {
  const { showNotification } = useNotificationService();
  const [comment, setComment] = useState("");
  const isSmall = useResponsive("down", "sm", "xl");
  const [loading, setLoading] = useState(false);
  const [petition_signed, setPetition_signed] = useState(
    Number(data?.signatures)
  );
  const account_profile = useSelector(
    (state: RootState) => state.content.account_profile_data
  );
  const sign_petition = async () => {
    setLoading(true);
    // send request to sign petition
    const result = await apiSignPetition({ comment, post_id: data?.id });

    if (result.status === 200) {
      showNotification(
        "Your signature has been submitted successfully!",
        "success"
      );
      setComment("");
      setPetition_signed((prev) => prev + 1);
      setLoading(false);
    } else {
      console.error("An error has occurred", result);
      if ("details" in result) {
        showNotification(result.details || "An error occurred", "error");
      }
      setComment("");
      setLoading(false);
    }

    setLoading(false);
  };

  const handle_submit = () => {
    sign_petition();
  };

  // Construct full URL
  const baseUrl = window.location.origin;
  const additionalPath = `/posts?post_id=${data?.id}`;
  const fullShareLink = `${baseUrl}${additionalPath}`;
  // Copy function using Clipboard API
  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(fullShareLink);
      showNotification("Link copied!", "success");
    } catch (err) {
      console.error("Failed to copy: ", err);
      showNotification("Failed to copy the link. Try again.", "error");
    }
  };

  return (
    <Box
      sx={{
        mt: 2,
        borderRadius: "8px",
        minHeight: 250,
        height: "100%",
        overflowY: "auto",
        width: isSmall ? 300 : "100%",
      }}
    >
      <Box
        sx={{
          border: "1px solid rgba(231, 235, 239, 1)",
          p: 3,
          pt: 2,
        }}
      >
        {/* progress */}
        <LineProgress
          current={petition_signed}
          total={Number(data?.target_signatures ?? 0)}
        />
        <Stack direction={"row"} justifyContent={"space-between"}>
          <Stack>
            <Typography sx={textSty}>{petition_signed}</Typography>
            <Typography sx={textSty}>Supporters</Typography>
          </Stack>
          <Stack>
            <Typography sx={textSty}>Goal</Typography>
            <Stack direction={"row"} spacing={1}>
              <Typography sx={textSty}>{data?.target_signatures}</Typography>
              <Typography sx={textSty}>Signature</Typography>
            </Stack>
          </Stack>
        </Stack>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          sx={{ my: 2 }}
        >
          <Typography sx={{ ...textSty, fontWeight: 500 }}>
            Directed to:
          </Typography>
          <Stack>
            {data?.target_representatives?.map(
              (
                target: { id: number; name: string; photo_url: string },
                id: number
              ) => (
                <Typography key={id} sx={{ ...textSty, fontWeight: 500 }}>
                  {target?.name}
                </Typography>
              )
            )}
          </Stack>
        </Stack>
        <Stack>
          {/* <CopyToClipboard
            text={fullShareLink}
            onCopy={() => showNotification("Link copied!", "success")}
          > */}
          <Button
            variant="contained"
            startIcon={<UploadIcon />}
            onClick={copyToClipboard}
            sx={{
              backgroundColor: "#0A0B0A",
              borderRadius: "40px",
            }}
          >
            Share Petition
          </Button>
          {/* </CopyToClipboard> */}
        </Stack>

        <Stack sx={{ my: 2 }}>
          <Typography color="black" sx={{ fontWeight: 500 }} variant="h5">
            Sign petition
          </Typography>
          <Stack
            direction={"row"}
            spacing={1}
            alignItems={"center"}
            sx={{ my: 1 }}
          >
            <img
              src={account_profile?.image}
              alt=""
              width={28}
              height={28}
              style={{ borderRadius: "40px" }}
            />
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {account_profile?.name}
            </Typography>
          </Stack>
        </Stack>
        <Stack>
          <InputLabel
            sx={{
              color: "#7991A4",
              fontWeight: 500,
              fontSize: 12,
              mb: 1,
            }}
          >
            Why signing this petition (optional)
          </InputLabel>
          <TextField
            multiline
            rows={4}
            value={comment}
            onChange={(
              event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            ) => setComment(event.target.value)}
          />
          <Stack direction={"column"} alignItems={"center"}>
            <Button
              variant="contained"
              onClick={handle_submit}
              color="primary"
              startIcon={<HandsFistIcon />}
              sx={{
                mt: 2,
                borderRadius: "40px",
                width: 300,
                backgroundColor: '#459173'
              }}
            >
              Continue
            </Button>
            {loading && <LoadingSpinner />}
          </Stack>
        </Stack>
      </Box>
    </Box>
  );
};

export default SignPetitionContainer;
